<template lang="pug">
    #Box
        portal(to="modals")
            div#modal-box(v-if="showModal" @click.self="closeModal")
                div.modal
                    .top
                        .img(v-if="selectedItem.image")
                            img(:src="selectedItem.image").image
                        .text
                            h3 Baixar relatório
                            h2 {{ selectedItem.title }}
                            h3 2026
                    .bottom
                        h2 Para continuar, informe o seu perfil:
                        select(v-model="perfilId")
                            option(:value="null" disabled) Selecione o seu perfil
                            option(v-for="perfil in perfis", :value="perfil.id") {{perfil.label}}
                        p.text Esta informação é usada apenas para entender o perfil de quem acessa nosso relatório. Nenhum dado pessoal é solicitado.
                        p.error(v-if="errorMessage") {{ errorMessage }}
                        button(:disabled="!perfilId || loading" :class="{ active: perfilId, loading: loading }" @click="handleDownload")
                            span(v-if="!loading")
                                |Baixar relatório 
                                SvgIcon(data="@svgs/download.svg", original)
                            span(v-else) Enviando...

        ul
            li(v-for="item in boxes")
                a(
                    v-if="!shouldOpenModal(item)"
                    :href="item.link"
                )
                    .img(v-if="item.image")
                        img(:src="item.image").image
                    h3 {{ item.title }}
                    p {{ item.text }}
                    span {{ item.call }}
                div(
                    v-else
                    @click="openModal(item)"
                    style="cursor: pointer"
                )
                    .img(v-if="item.image")
                        img(:src="item.image").image
                    h3 {{ item.title }}
                    p {{ item.text }}
                    span {{ item.call }}
</template>

<script>
import { props } from '@/mixins/component';

export default {
    name: "box",
    data() {
        return {
            showModal: false,
            selectedItem: null,
            perfis: [
                { id: 1, label: 'Cooperado' },
                { id: 2, label: 'Funcionário' },
                { id: 3, label: 'Membro do conselho ou Diretor' },
                { id: 4, label: 'Comunidade' },
                { id: 5, label: 'Instituição Financeira' },
                { id: 6, label: 'Consumidor/Cliente' },
                { id: 7, label: 'Fornecedor/Representante Comercial' },
                { id: 8, label: 'Outros' },
            ],
            perfilId: null,
            errorMessage: null,
            loading: false,
        }
    },
    props,
    computed: {
        boxes() {
            return this.contents.content.map(item => ({
                ...item,
                image: this.getBoxImage(item)
            }))
        },
        news() {
            return this.$store.state.news.map(news => ({
                ...news,
                translations: news.translations.map(translation => ({
                    thumb: translation.thumb ? translation.thumb.filePath : ``,
                }))    
            }))
        },
        magazines() {
            return this.$store.state.magazines
        },
    },
    methods: {
        handleClick(item) {
            if (this.shouldOpenModal(item.link)) {
                this.selectedItem = item
                this.showModal = true
            } else {
                window.open(item.link, '_self')
            }
        },
        shouldOpenModal(item) {
            return item.link.includes('Relatorio_de_Sustentabilidade_COAMO-2025.pdf')
        },
        openModal(item) {
            this.selectedItem = item
            this.showModal = true
        },
        closeModal() {
            this.showModal = false
            this.perfilId = null
            this.errorMessage = null
        },
        async handleDownload() {
            if (!this.perfilId || this.loading) return

            this.loading = true
            this.errorMessage = null

            try {
                await this.$axios.post('/reports', {
                    type: this.perfilId - 1,
                })

                // abre o download
                if (this.selectedItem?.link) {
                    window.open(this.selectedItem.link, '_blank')
                }

                this.closeModal();

            } catch (error) {
                this.errorMessage = 'Não foi possível enviar. Tente novamente.'
                console.error(error)
            } finally {
                this.loading = false
            }
        },
        getBoxImage(item) {
            switch(item.type) {
                case 'image': return item.image ?? null;
                case 'lastMagazine': {
                    if (this.magazines.length === 0) return '';
                    // const editions = this.magazines.map(magazine => magazine.edition);
                    // const lastEdition = Math.max(...editions)
                    // const lastMagazine = this.magazines.find(magazine => magazine.edition === lastEdition)

                    let lastMagazine;
                    for (let magazine of this.magazines) {
                        if (!(lastMagazine?.edition > magazine.edition)) lastMagazine = magazine;
                    }
                    return lastMagazine.image.filePath;
                }
                case 'lastNews': {
                    if (this.news.length === 0) return '';
                    return this.news[0].translations[0].thumb;
                }
            }
        }
    },
    created() {
        this.$store.dispatch('fetchNews', { skip: 0, take: 1 })
        this.$store.dispatch('fetchMagazines')
    },
}
</script>

<style lang="stylus" scoped src="./Box.styl"></style>
